/** XRBodyModifier3D registration: the parser, which reads `active` and `influence`. index.r3f.ts holds its effect on the pose. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseSkeletonModifier3D } from '../skeletonmodifier3d/parser';
const registration = {
    typeName: 'XRBodyModifier3D',
    parser: parseSkeletonModifier3D,
};
nodeRegistry.register(registration);
//# sourceMappingURL=index.js.map